<script setup lang="ts">
const props = defineProps<{
  labelText: string
  modelValue: string
  value: string
}>()

const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()

function toggleSelection() {
  emit('update:modelValue', props.value)
}

function isSelected() {
  return props.modelValue === props.value && '!border-4'
}

function isSelectedWithoutBorder() {
  return props.modelValue === props.value
}
</script>

<template>
  <div>
    <label class="flex cursor-pointer select-none items-center">
      <div class="relative">
        <input
          type="radio"
          class="sr-only"
          :checked="isSelectedWithoutBorder()"
          @change="toggleSelection"
        />
        <div
          :class="isSelected()"
          class="box mr-2 flex h-5 w-5 items-center justify-center border border-blue"
        ></div>
      </div>
      <span class="font-medium text-black">{{ labelText }}</span>
    </label>
  </div>
</template>